import { IRoutePermissions } from 'types/common';
import { mappingsRoutePerm } from '../../domains/Mappings/routePermissions';
import { policyManagerRoutePerm } from '../../domains/PolicyManager/routePermissions';
import {
  identityEventLogsRoutePerm,
  organizationsRoutePerm,
  usersRoutePerm,
} from '../Routes/routePermissions';
import { INavGroup, INavItem } from '@ent-ui-kit/react';

export interface ILayoutNavItem extends INavItem {
  permissions: IRoutePermissions;
}

export interface ILayoutNavGroup extends INavGroup {
  items: ILayoutNavItem[];
}

export const navItems: ILayoutNavGroup[] = [
  {
    id: 'main',
    items: [
      {
        label: 'Organizations',
        path: '/organizations',
        icon: 'ki-office-f',
        permissions: organizationsRoutePerm,
      },
      {
        label: 'Users',
        path: '/users',
        icon: 'ki-person-multi-f',
        permissions: usersRoutePerm,
      },
    ],
  },
  {
    id: 'policy',
    items: [
      {
        label: 'Policy Manager',
        path: '/policy-manager',
        icon: 'ki-lock-f',
        permissions: mappingsRoutePerm,
      },
      {
        label: 'Mappings',
        path: '/mappings',
        icon: 'ki-document-f',
        permissions: policyManagerRoutePerm,
      },
    ],
  },
  {
    id: 'logs',
    items: [
      {
        label: 'Activity Logs',
        path: '/event-logs',
        icon: 'ki-activity-f',
        permissions: identityEventLogsRoutePerm,
      },
    ],
  },
];
